/** Recuperado del despliegue 2026-10-05. Conserva lógica y memoización originales. */
import {
  rec_EstadoError as EstadoError,
  rec_JSXRuntime as JSXRuntime,
  rec_React as React,
  rec_api as api,
  rec_ii as ii,
  rec_mr as mr,
  rec_uS as uS,
} from "../../runtime/index.jsx";
export function ActividadProyecto({ proyecto: e }) {
  let [t, n] = (0, React.useState)([]),
    [r, i] = (0, React.useState)(!0),
    [a, o] = (0, React.useState)(``),
    s = (0, React.useCallback)(async () => {
      i(!0);
      try {
        (n(await api(`/actividad?proyecto=${e.id}&limite=60`)), o(``));
      } catch (e) {
        o(e.message);
      } finally {
        i(!1);
      }
    }, [e.id]);
  return (
    (0, React.useEffect)(() => {
      s();
    }, [s]),
    r ? (
      <div
        className={`flex items-center gap-2 text-sm text-(--text)`}
        children={[
          (0, JSXRuntime.jsx)(ii, {
            className: `h-4 w-4 animate-spin`,
          }),
          ` Cargando…`,
        ]}
      />
    ) : (
      <div
        className={`flex flex-col gap-3`}
        children={[
          <EstadoError mensaje={a} onReintentar={s} />,
          t.length === 0 ? (
            <div
              className={`rounded-2xl border border-dashed border-(--border) p-10 text-center`}
              children={[
                (0, JSXRuntime.jsx)(mr, {
                  className: `mx-auto h-8 w-8 text-(--text)`,
                }),
                <p
                  className={`mt-2 text-sm text-(--text)`}
                  children={`Sin actividad todavia.`}
                />,
              ]}
            />
          ) : (
            <ul
              className={`flex flex-col`}
              children={t.map((e) => (
                <li
                  key={e.id}
                  className={`flex gap-3 border-b border-(--border) py-2.5 text-sm last:border-0`}
                  children={[
                    <span
                      className={`mt-1.5 h-1.5 w-1.5 shrink-0 rounded-full bg-(--accent)`}
                    />,
                    <span
                      className={`flex-1 text-(--text-h)`}
                      children={[
                        <strong children={e.actorNombre || `Alguien`} />,
                        ` `,
                        e.verbo,
                        ` `,
                        e.objeto,
                      ]}
                    />,
                    <span
                      className={`shrink-0 text-xs text-(--text)`}
                      children={uS(e.creadoEn)}
                    />,
                  ]}
                />
              ))}
            />
          ),
        ]}
      />
    )
  );
}
